import AppDataService from "./AppDataService";

const COMMON_BASE = 'Payment'

export default class PaymentDataService {

    static async getPrepaidAmount() {
        return await AppDataService.get(`${COMMON_BASE}/GetPrepaidAmount`)
    }

    static async getPurchasePlanAmounts() {
        return await AppDataService.get(`${COMMON_BASE}/GetPurchasePlanAmounts`)
    }

    static async purchasePlan(data) {
        return await AppDataService.post(`${COMMON_BASE}/PurchasePlan`, data)
    }

    static async getPrepaySalesTaxAmount(totalAmount) {
        return await AppDataService.get(`${COMMON_BASE}/GetPrepaySalesTaxAmount?totalamount=${totalAmount}`)
    }

    static async GetSavedCardsList() {
        return await AppDataService.get(`${COMMON_BASE}/GetSavedCardsList`)
    }

    static async getSavedCardAddress(params) {
        return await AppDataService.get(`${COMMON_BASE}/Getsavedcardaddress`, { params })
    }

    static async getSalesTaxAmount(data) {
        return await AppDataService.post(`${COMMON_BASE}/GetSalesTaxAmount`, data)
    }

    static async submitPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/SubmitPayment`, data)
    }

    static async getDiscountCoupon(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetDiscountAmount`, { params })
    }

    static async GetStripeCardDetailsById(params) {
        return await AppDataService.get(`${COMMON_BASE}/GetStripeCardDetailsById`, {params}); 
    }

    static async addBalanceToPrepayWallet(data) {
        return await AppDataService.post(`${COMMON_BASE}/AddPrepayFund`, data);
    }

    static async submitAllPayersPayment(data) {
        return await AppDataService.post(`${COMMON_BASE}/SubmitAllPayersPayment`, data)
    }

    static async addCardDetails(data) {
        return await AppDataService.post(`${COMMON_BASE}/AddStripecard`, data)
    }

    static async getSavedAddress() {
        return await AppDataService.get(`${COMMON_BASE}/GetSavedAddress`)
    }

    static async setDefaultCard(cardObj) {
        return await AppDataService.put(`${COMMON_BASE}/MakeDefaultCard?cardId=${cardObj.Value}`)
    }
    
    static async getUserPlanExpiryDate(){
        return await AppDataService.get(`${COMMON_BASE}/GetUserPlanExpiryDate`)
    }
}